import { Link } from '@billy/design-system'
import { MouseEvent, ReactElement, useCallback } from 'react'

import { useTransactionView } from '@features/transactions/contexts/transactionViewContext'

interface TransactionLinkProps {
  transaction: string | undefined
  transactionId: string | undefined
}

export const TransactionLink = ({ transaction, transactionId }: TransactionLinkProps): ReactElement => {
  const { handleTransactionClick } = useTransactionView()

  const handleClick = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation()

      if (!transactionId) {
        return
      }

      handleTransactionClick({ id: transactionId })
    },
    [handleTransactionClick, transactionId],
  )

  return (
    <Link onClick={handleClick} withAnimation>
      {transaction}
    </Link>
  )
}
